import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShellGatewayService } from './shell-gateway.service';
import { Initials } from '../../models/initials.model';
import { Login } from '../../models/Login.model';

@Injectable({
    providedIn: 'root'
})
export class ShellFacadeService {

    constructor(private shellGatewayService: ShellGatewayService) {
    }

    public getShellInitial(): Observable<Initials> {
        return this.shellGatewayService.getShellInitial();
    }

    public addUserRefreshToken(refresh: string): Observable<Login> {
        return this.shellGatewayService.addUserRefreshToken(refresh);
    }
}
